// extracted by mini-css-extract-plugin
export default {"PillToggler":"Viewer_PillToggler__JbPTm","PillItem":"Viewer_PillItem__46KlS","PillActive":"Viewer_PillActive__K6Dfo","TableContainer":"Viewer_TableContainer__NYpJF"};